import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
// const shortcuts = useSearchDateShortcut()

const shortcuts =
  [
    {
      text: '今天',
      value: () => {
        // 获取昨天的开始时间（00:00:00）
        const start = new Date();
        start.setDate(start.getDate());
        start.setHours(0, 0, 0, 0);
        // 获取昨天的结束时间（23:59:59）
        const end = new Date();
        end.setDate(end.getDate());
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    },
    {
      text: '昨天',
      value: () => {
        // 获取昨天的开始时间（00:00:00）
        const start = new Date();
        start.setDate(start.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        // 获取昨天的结束时间（23:59:59）
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    },
    {
      text: '近7天',
      value: () => {
        const start = new Date();
        start.setDate(start.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    },
    {
      text: '近30天',
      value: () => {
        const start = new Date();
        start.setDate(start.getDate() - 30);
        start.setHours(0, 0, 0, 0);
        const end = new Date();
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        return [start, end]
      }
    }
  ]

export const searchFormConfig: IForm = {
  formItems: [
    {
      label: '手机号',
      field: 'customPhone',
      type: 'input',
      placeholder: '请输入手机号'
    },
    {
      label: '状态',
      field: 'status',
      type: 'select',
      clearable: true,
      placeholder: '请选择状态',
      options: [
        { title: '已接通', value: '已接通' },
        { title: '未接通', value: '未接通' },
        { title: '意向', value: '意向'},
        { title: '加个微', value: '加个微'},
        { title: '加企微', value: '加企微'},
        { title: '已成交', value: '已成交'}
      ]
    },
    {
      label: '渠道来源',
      field: 'sourceChannel',
      type: 'select',
      clearable: true,
      placeholder: '请输入渠道来源',
      options: [
        { title: 'gdt', value: 'gdt' },
        { title: 'gx', value: 'gx' },
        { title: 'tz', value: 'tz' },
        { title: '高', value: '高' }
      ]
    },
    {
      label: '归属组别',
      field: 'vestDeptName',
      type: 'select',
      clearable: true,
      placeholder: '请输入归属组别',
      options: [
        { title: '电话小组', value: '电话小组' },
        { title: '新兵营', value: '新兵营' }
      ]
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '入库时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate());
          return yesterday < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
